<template>
  <app-navigation></app-navigation>
</template>

<script>
import Navigation from "@/components/Base/Navigation";

export default {
  name: "Home",
  components: {
    "app-navigation": Navigation
  }
};
</script>
